import type {Actions, Store} from './types';

const getInstanceMetadata = (state: Store, instanceId: string) => {
  if (!state.byInstance) {
    state.byInstance = {};
  }

  if (!state.byInstance[instanceId]) {
    state.byInstance[instanceId] = {
      metadataColumns: [],
      hiddenColumns: [],
      metadataList: [],
      templates: [],
      templateId: null,
      templateDb: {},
      isLoading: false,
      columnWidths: {},
      sortState: {
        columnId: null,
        direction: 'desc',
      },
    };
  }

  return state.byInstance[instanceId];
};

export function setMetadataColumns(
  state: Store,
  action: Actions['setMetadataColumns'],
) {
  const {instanceId, columns} = action.payload;
  const instanceMetadata = getInstanceMetadata(state, instanceId);
  instanceMetadata.metadataColumns = columns;
}

export function setHiddenColumns(
  state: Store,
  action: Actions['setHiddenColumns'],
) {
  const {instanceId, hiddenColumns} = action.payload;
  const instanceMetadata = getInstanceMetadata(state, instanceId);
  instanceMetadata.hiddenColumns = hiddenColumns;
}

export function setMetadataList(
  state: Store,
  action: Actions['setMetadataList'],
) {
  const {instanceId, list} = action.payload;
  const instanceMetadata = getInstanceMetadata(state, instanceId);
  instanceMetadata.metadataList = list;
}

export function setTemplates(state: Store, action: Actions['setTemplates']) {
  const {instanceId, templates} = action.payload;
  const instanceMetadata = getInstanceMetadata(state, instanceId);
  instanceMetadata.templates = templates;
}

export function setTemplateId(state: Store, action: Actions['setTemplateId']) {
  const {instanceId, templateId} = action.payload;
  const instanceMetadata = getInstanceMetadata(state, instanceId);
  instanceMetadata.templateId = templateId;
}

export function setTemplateDb(state: Store, action: Actions['setTemplateDb']) {
  const {instanceId, templateDb} = action.payload;
  const instanceMetadata = getInstanceMetadata(state, instanceId);
  instanceMetadata.templateDb = templateDb;
}

export function updateTemplateDb(
  state: Store,
  action: Actions['updateTemplateDb'],
) {
  const {instanceId, templates} = action.payload;
  const instanceMetadata = getInstanceMetadata(state, instanceId);
  instanceMetadata.templateDb = {
    ...instanceMetadata.templateDb,
    ...templates,
  };
}

export function setIsLoading(state: Store, action: Actions['setIsLoading']) {
  const {instanceId, isLoading} = action.payload;
  const instanceMetadata = getInstanceMetadata(state, instanceId);
  instanceMetadata.isLoading = isLoading;
}

export function setColumnWidths(
  state: Store,
  action: Actions['setColumnWidths'],
) {
  const {instanceId, columnWidths} = action.payload;
  const instanceMetadata = getInstanceMetadata(state, instanceId);
  instanceMetadata.columnWidths = columnWidths;
}

export function updateColumnWidth(
  state: Store,
  action: Actions['updateColumnWidth'],
) {
  const {instanceId, columnId, width} = action.payload;
  const instanceMetadata = getInstanceMetadata(state, instanceId);
  instanceMetadata.columnWidths = {
    ...instanceMetadata.columnWidths,
    [columnId]: width,
  };
}

export function setSortState(state: Store, action: Actions['setSortState']) {
  const {instanceId, columnId, direction} = action.payload;
  const instanceMetadata = getInstanceMetadata(state, instanceId);
  instanceMetadata.sortState = {columnId, direction};
}

export function rearrangeColumns(
  state: Store,
  action: Actions['rearrangeColumns'],
) {
  const {instanceId, startIndex, endIndex} = action.payload;
  const instanceMetadata = getInstanceMetadata(state, instanceId);

  const newCols = [...instanceMetadata.metadataColumns];
  const [toMove] = newCols.splice(startIndex, 1);
  newCols.splice(endIndex, 0, toMove);

  instanceMetadata.metadataColumns = newCols;
}

export function purge(state: Store) {
  state.byInstance = {};
}
